import {Model} from "ords/dist/model/model";

export class AssignmentPage extends Model {

}

export const AssignmentPageModelConfig = {
    name: 'assignmentPage',
    model: AssignmentPage,
    relations: [
        {name: 'parts', model_name: 'assignmentPart', type: 'hasMany'},
        {name: 'sub_assignment', model_name: 'subAssignment', type: 'hasOne'}
    ]
}
